import { Component, Input } from '@angular/core';
import { CustomButtonComponent } from "../../../../shared/components/custom-button/custom-button.component";
import { FormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { CommonValidatorService } from '../../../../core/services/validators/common-validator.service';
import { TranslocoPipe } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';
import { LabeledInputComponent } from "../../../../shared/components/labeled-input/labeled-input.component";
import { AuthValidatorService } from '../../../../core/services/validators/auth-validator.service';
import { SalesAgentCreate, SalesAgentGet } from '../../../../core/interfaces/sales-agents-interfaces';
import { firstValueFrom } from 'rxjs';
import { SalesAgentsService } from '../../../../core/api/sales-agents.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ApiErrorService } from '../../../../core/api/api-error.service';

@Component({
  selector: 'app-create-sales-agent-dialog',
  standalone: true,
  imports: [CustomButtonComponent, FormsModule, DialogModule, TranslocoPipe, CommonModule, LabeledInputComponent],
  templateUrl: './create-sales-agent-dialog.component.html',
  styleUrl: './create-sales-agent-dialog.component.css'
})
export class CreateSalesAgentDialogComponent {
  visible: boolean = false;

  @Input() reloadAgentsCallbackFunction!: () => void;

  // Text Inputs
  nameInput: string = '';
  nameInputError: string | null = null;

  emailInput: string = '';
  emailInputError: string | null = null;

  contactNumberInput: string = '';
  contactNumberInputError: string | null = null;

  // Dialog error
  dialogErrorMessage: string | null = null;

  // Button click
  confirmClicked: boolean = false;

  constructor(private commonValidator: CommonValidatorService, private authValidatior: AuthValidatorService, private salesAgentsService: SalesAgentsService, private apiError: ApiErrorService) { }

  openModal(editLocation?: Location): void {
    this.visible = true;

    this.resetDialogData();
  }

  closeModal(): void {
    this.visible = false;
  }

  resetDialogData() {
    this.dialogErrorMessage = null;

    this.nameInputError = null;
    this.emailInputError = null;
    this.contactNumberInputError = null;

    this.nameInput = '';
    this.emailInput = '';
    this.contactNumberInput = '';

    this.confirmClicked = false;
  }

  validateInputs(): boolean {
    const nameInputValue = this.nameInput.trim();
    const emailInputValue = this.emailInput.trim();
    const contactNumberInputValue = this.contactNumberInput.trim();

    // Validate length for text inputs
    const nameError = this.commonValidator.validateLength(nameInputValue, 2, 255);
    const emailError = this.authValidatior.validateEmail(emailInputValue);
    const contactNumberError = this.commonValidator.validateLength(contactNumberInputValue, 1, 255);

    // Show errors
    this.nameInputError = nameError;
    this.emailInputError = emailError;
    this.contactNumberInputError = contactNumberError;

    // If there are any errors show them and prevent submission
    if (
      nameError || emailError || contactNumberError) {
      return false;
    }

    return true;
  }

  async confirmButtonClick() {
    if (this.confirmClicked) {
      return;
    }
    this.confirmClicked = true;

    if (!this.validateInputs()) {
      this.confirmClicked = false;
      return;
    }

    // Create agent
    const newSalesAgent: SalesAgentCreate = {
      name: this.nameInput.trim(),
      email: this.emailInput.trim(),
      contact_number: this.contactNumberInput.trim()
    }
    var responseNewSalesAgent: SalesAgentGet | undefined;

    // Send request for creating location
    try {
      responseNewSalesAgent = await firstValueFrom(this.salesAgentsService.createSalesAgent(newSalesAgent));
    } catch (error) {
      var crid = 'UNKNOWN-CRID';
      if (error instanceof HttpErrorResponse) {
        crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
      }
      this.dialogErrorMessage = `${await this.apiError.getErrorHeader()} ${await this.apiError.getErrorMessage(crid)}`;
      this.confirmClicked = false;
      return;
    }

    this.dialogErrorMessage = null;
    this.confirmClicked = false;

    // Add location electricity and gas data
    if (this.reloadAgentsCallbackFunction) {
      this.reloadAgentsCallbackFunction();
    }

    this.closeModal();
  }
}
